import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ff300b",
      d: "M13.2 15.5a2.7 2.7 0 0 1 2.3-2.3l2-.2c.6 0 1.3 0 2 .2 1.2.1 2.2 1 2.3 2.3l.2 2c0 .6 0 1.3-.2 2a2.7 2.7 0 0 1-2.3 2.3l-2 .2c-.6 0-1.3 0-2-.2a2.7 2.7 0 0 1-2.3-2.3l-.2-2c0-.6 0-1.3.2-2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ffc310",
      d: "M2.2 15.5a2.7 2.7 0 0 1 2.3-2.3l2-.2c.6 0 1.3 0 2 .2 1.2.1 2.2 1 2.3 2.3l.2 2c0 .6 0 1.3-.2 2a2.7 2.7 0 0 1-2.3 2.3l-2 .2c-.6 0-1.3 0-2-.2a2.7 2.7 0 0 1-2.3-2.3l-.2-2c0-.6 0-1.3.2-2m11-11a2.7 2.7 0 0 1 2.3-2.3l2-.2c.6 0 1.3 0 2 .2 1.2.1 2.2 1 2.3 2.3l.2 2c0 .6 0 1.3-.2 2a2.7 2.7 0 0 1-2.3 2.3l-2 .2c-.6 0-1.3 0-2-.2a2.7 2.7 0 0 1-2.3-2.3l-.2-2c0-.6 0-1.3.2-2m-11 0a2.7 2.7 0 0 1 2.3-2.3l2-.2c.6 0 1.3 0 2 .2 1.2.1 2.2 1 2.3 2.3l.2 2c0 .6 0 1.3-.2 2a2.7 2.7 0 0 1-2.3 2.3l-2 .2c-.6 0-1.3 0-2-.2a2.7 2.7 0 0 1-2.3-2.3l-.2-2c0-.6 0-1.3.2-2"
    }, null, -1)
  ]))]))
}
export default { render: render }